import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useOktaAuth } from '@okta/okta-react';
import { TdsLoadingSpinner } from '@trv-tds/react';

export const LoginCallback = () => {
  const { oktaAuth } = useOktaAuth();
  const navigate = useNavigate(); 

  useEffect(() => {
    oktaAuth.handleLoginRedirect().then(() => {
      const originalUri = oktaAuth.getOriginalUri();
      if (originalUri) {
        navigate(originalUri.replace(window.location.origin, ''), { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    }).catch((error) => {
      console.error('Login callback error:', error);
      navigate('/', { replace: true });
    });
  }, [oktaAuth, navigate]);

  return <TdsLoadingSpinner centered label="Completing sign in..." />;
};
